import GroupIcon from '@mui/icons-material/Group';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import {
  ArrayInput, AutocompleteInput, Button, ReferenceInput, SimpleFormIterator,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';

import AlbumContributorCreate from './Create/AlbumContributorCreate';
import { roleChoices } from '@/Helper/DropdownChoices/dropdownChoices';

function AlbumContributorsSection() {
  const [popupOpen, setPopupOpen] = useState(false);
  const { getValues, setValue } = useFormContext();
  // const refresh = useRefresh();

  const handleContributorSave = (contributorId: string) => {
    const currentContributors = getValues('DiscographyAlbumContributors') || [];

    setValue('DiscographyAlbumContributors', [
      ...currentContributors,
      {
        DiscographyContributorIdentifier: contributorId,
        Role: '',
      },
    ], { shouldDirty: true });

    // refresh();
    setPopupOpen(false);
  };

  return (
    <Box
      mb={3} width={{ xs: '100%', md: '70%' }}
      p={2} border={1}
      borderRadius={2} borderColor='grey.400'
    >
      <Typography
        variant='h6' gutterBottom
        display='flex' alignItems='center'
        gap={1}
      >
        <GroupIcon />
        Contributors
      </Typography>
      <ArrayInput source='DiscographyAlbumContributors' label=''>
        <SimpleFormIterator
          disableReordering
          disableClear
          sx={{
            '& .RaSimpleFormIterator-line': {
              border: 1,
              borderColor: 'grey.300',
              borderRadius: 1,
              padding: 2,
              marginBottom: 2,
            },
            '& > ul > li:last-child': {
              borderBottom: '1px solid',
              borderColor: 'grey.300',
            },
          }}
        >
          <ReferenceInput
            source='DiscographyContributorIdentifier'
            reference='contributors'
            sort={{ field: 'Name', order: 'ASC' }}
            perPage={20}
          >
            <AutocompleteInput
              label='Contributor'
              optionText='Name'
              optionValue='id'
              filterToQuery={(q) => ({ Name: q })}
              fullWidth
            />
          </ReferenceInput>
          <AutocompleteInput
            source='Role'
            label='Role'
            choices={roleChoices}
            fullWidth
          />
        </SimpleFormIterator>
      </ArrayInput>
      <Button
        label='Create Contributor' onClick={() => setPopupOpen(true)}
        sx={{ mt: 2 }}
      />
      <AlbumContributorCreate
        open={popupOpen}
        onClose={() => setPopupOpen(false)}
        onSave={handleContributorSave}
      />
    </Box>
  );
}

export default AlbumContributorsSection;
